export default "__VITE_ASSET__ugfDefai__"